import { UserTagRequest } from "./userTagRequest";

export class UserTagsWithAssignmentNameRequest {
    userTags : UserTagRequest[];
    assignmentName : string;
    managerId : number;
    time : number;

    constructor() {
        this.userTags = [];
        this.assignmentName = "";
        this.managerId = 0;
        this.time = 0;
    }
}